// extracted by mini-css-extract-plugin
export default {"container":"container-b5I19HMEO3j0a_kdib9u"};